import { Controller } from "@hotwired/stimulus";
import Swiper, { Autoplay, Navigation, Thumbs } from "swiper";

export default class extends Controller {
    static targets = [
        'swiper',
        'swiperThumbs',
        'prev',
        'next',
        'thumb',
    ]

    connect() {
        Swiper.use([Navigation, Autoplay])

        this.swiperThumbs = new Swiper(this.swiperThumbsTarget, {
            loop: false,
            centeredSlides: true,
            spaceBetween: 0,
            freeMode: true,
            watchSlidesProgress: true,
            slidesPerView: 'auto',
        })

        this.swiper = new Swiper(this.swiperTarget, {
            loop: false,
            navigation: {
                prevEl: this.prevTarget,
                nextEl: this.nextTarget,
                disabledClass: 'disabled',
            },
        })

        controlSwiper(this.swiper, this.swiperThumbs);
        controlSwiper(this.swiperThumbs, this.swiper);

        this.swiper.on('slideChange', (swiper) => {
            const activeIndex = swiper.realIndex | 0;

            this.setActiveThumb(activeIndex)
        })

        this.setActiveThumb(0)
    }

    setActiveThumb(activeIndex) {
        this.thumbTargets.forEach((element, index) => {
            // element.classList.toggle('w-72', index === activeIndex)
            element.classList.toggle('scale-90', index !== activeIndex)
        });
    }

    /**
    * @param {Event} event 
    */
    setActive(event) {
        const el = event.currentTarget

        const index = this.thumbTargets.indexOf(el);

        this.swiper.slideTo(index)
    }

    disconnect() {
        this.swiperThumbs.destroy();
        this.swiper.destroy();
    }
}

function getCurrentIndex(swiper) {
    // Apparently the `realIndex` property might be a string?
    return swiper.realIndex | 0;
}

function getTotalSlides(swiper) {
    // Looped carousels include leading/lagging slides which buffs the length of this array
    return swiper.slides.length - (swiper.params.loop ? 2 : 0);
}

function changeSlide(swiper, index) {
    const currentIndex = getCurrentIndex(swiper);
    const total = getTotalSlides(swiper);

    // Only change the slide if the new index is different to the current
    // This is important if two carousels are controlling each other, as without this check the program will go into an infinite loop and overflow the stack
    if (currentIndex !== index) {
        // If the carousel loops around, then we want to ensure it truly does loop - simply using the `slideTo` method doesn't actually account for looping
        // The idea is to check if the new index is directly before or after the current, and if so, use the `slidePrev`/`slideNext` methods that *do* account for looping
        if (swiper.params.loop) {
            if ((index === 0 && currentIndex === total - 1) || index === currentIndex + 1) {
                swiper.slideNext();
            } else if ((index === total - 1 && currentIndex === 0) || index === currentIndex - 1) {
                swiper.slidePrev();
            } else {
                // Need to buffer the index to account for the leading/lagging slides
                swiper.slideTo(index + 1);
            }
        } else {
            swiper.slideTo(index);
        }
    }
}

function controlSwiper(controller, target) {
    // Listens for a `transitionStart` event, as none of the other slide changing events seemed to trigger at all
    controller.on('transitionStart', function () {
        const index = getCurrentIndex(controller);
        changeSlide(target, index);
    });
}
